// extracted by mini-css-extract-plugin
export default {"sharing":"sharing-b7bL"};